import Vue from 'vue'
import Vuex from 'vuex'


import agentes from './Agentes'
import interacciones from './Interacciones'
import graficos from './Graficos'


Vue.use(Vuex)


export default function () {
    const Store = new Vuex.Store({
      modules: {
        agentes,
        interacciones,
        graficos
      },
  
      // enable strict mode (adds overhead!)
      // for dev mode only
      strict: process.env.DEBUGGING
    })
  
    return Store
  }
  